import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateComplianceRecordMutation } from "../graphql/mutations";
import type {
  CreateComplianceRecordMutationType,
  CreateComplianceRecordMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateComplianceRecordMutation = (
  options?: MutationHookOptions<
    CreateComplianceRecordMutationType,
    CreateComplianceRecordMutationVariablesType
  >
) => {
  return useMutation<
    CreateComplianceRecordMutationType,
    CreateComplianceRecordMutationVariablesType
  >(CreateComplianceRecordMutation, options);
};
